(function () {
  const filterRoots = document.querySelectorAll('[data-filter-drawer-root]');

  if (!filterRoots.length) {
    return;
  }

  const closeAllDrawers = () => {
    document.body.classList.remove('is-filter-open');

    filterRoots.forEach((root) => {
      const drawer = root.querySelector('[data-filter-drawer]');
      const backdrop = root.querySelector('[data-filter-close].fw-filter-backdrop');
      const trigger = document.querySelector(`[data-filter-open][aria-controls="${drawer && drawer.id}"]`);

      if (drawer) {
        drawer.setAttribute('aria-hidden', 'true');
      }

      if (backdrop) {
        backdrop.hidden = true;
      }

      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  };

  const openDrawer = (trigger) => {
    const drawerId = trigger.getAttribute('aria-controls');
    const drawer = document.getElementById(drawerId);

    if (!drawer) {
      return;
    }

    const root = drawer.closest('[data-filter-drawer-root]');
    const backdrop = root && root.querySelector('[data-filter-close].fw-filter-backdrop');
    const closeButton = drawer.querySelector('[data-filter-close]');

    closeAllDrawers();
    document.body.classList.add('is-filter-open');
    drawer.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');

    if (backdrop) {
      backdrop.hidden = false;
    }

    if (closeButton) {
      closeButton.focus();
    }
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-filter-open]');
    const closeButton = event.target.closest('[data-filter-close]');

    if (openButton) {
      openDrawer(openButton);
      return;
    }

    if (closeButton) {
      closeAllDrawers();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllDrawers();
    }
  });
})();
